<section class="now-next-panel">
  <header class="now-next-panel__header">
    <h3 class="now-next-panel__title">{{ t('title') }}</h3>

    <div class="now-next-panel__controls">
      <e-segmented-toggle
        testId="now-next-sort"
        [options]="sortOptions()"
        [value]="sortMode()"
        (valueChange)="setSortMode($event)"
      ></e-segmented-toggle>
      <e-segmented-toggle
        testId="now-next-view"
        [options]="viewOptions()"
        [value]="viewMode()"
        (valueChange)="setViewMode($event)"
      ></e-segmented-toggle>
    </div>

    <hd-transit-legend-filter class="now-next-panel__legend" [showChiron]="showChiron()" />
  </header>

  @if (loading()) {
    <div class="now-next-panel__loading">
      <e-splash-loader [size]="40" />
    </div>
  } @else if (error() != null || rows().length === 0) {
    <p class="now-next-panel__empty">{{ t('emptyState') }}</p>
  } @else if (viewMode() === 'cards') {
    <!-- Card view: uniforme info-cards die de beschikbare ruimte vullen. -->
    <div class="now-next-panel__cards">
      @for (row of rows(); track row.planetId) {
        <hd-transit-info-card
          class="now-next-panel__card"
          role="button"
          tabindex="0"
          [data]="row.cardData"
          (click)="openShiftPopup(row, $event)"
          (keydown)="onCardKeydown(row, $event)"
        />
      }
    </div>
  } @else {
    <ul class="now-next-panel__rows">
      @for (row of rows(); track row.planetId; let i = $index) {
        <!-- Countdown apart uit de tick-map: de rij-VM zelf is tick-onafhankelijk. -->
        @let countdown = countdowns().get(row.planetId);
        <li
          class="now-next-panel__item"
          [class.now-next-panel__item--even]="i % 2 === 0"
          [class.now-next-panel__item--odd]="i % 2 === 1"
        >
          <button
            type="button"
            class="planet-row"
            [style.border-left-color]="row.stripeColor"
            (click)="openShiftPopup(row, $event)"
          >
            <span class="planet-row__identity">
              <span class="planet-row__glyph" aria-hidden="true">{{ row.glyph }}</span>
              <span class="planet-row__name">{{ row.name }}</span>
              @if (row.retrograde) {
                <span class="planet-row__rx" aria-label="retrograde" title="retrograde">
                  {{ t('retrogradeBadge') }}
                </span>
              }
            </span>
            <span class="planet-row__shifts">
              <!-- Vaste kolommen (vorige · huidig · volgende · aftelling): de
                   huidige poort/lijn staat zo op elke rij op dezelfde x. De
                   nummers dragen hun keynote als tooltip, de pijltjes het
                   volledige wisseltijdstip. -->
              <span class="planet-row__line">
                @if (row.prevLine != null) {
                  <span class="shift shift--prev">
                    <span class="shift__value" [attr.title]="row.prevLineKeynote">{{ row.prevLine }}</span>
                    <span class="shift__arrow" [attr.title]="row.lineSinceTooltip">◂</span>
                  </span>
                }
                <span class="shift shift--current" [attr.title]="row.currentLineKeynote">{{ row.current }}</span>
                @if (row.nextLine != null) {
                  <span class="shift shift--next">
                    <span class="shift__arrow" [attr.title]="row.lineShiftAtTooltip">▸</span>
                    <span class="shift__value" [attr.title]="row.nextLineKeynote">{{ row.nextLine }}</span>
                  </span>
                }
                @if (countdown?.line; as lineCountdown) {
                  <span class="shift countdown">
                    {{ lineCountdown }}
                    <span class="shift__kind">({{ t('lineShiftLabel') }})</span>
                  </span>
                }
              </span>
              <span class="planet-row__gate">
                @if (row.prevGate != null) {
                  <span class="shift shift--prev">
                    <span class="shift__value" [attr.title]="row.prevGateKeynote">{{ row.prevGate }}</span>
                    <span class="shift__arrow" [attr.title]="row.gateSinceTooltip">◂</span>
                  </span>
                }
                <span class="shift shift--gate-current" [attr.title]="row.currentGateKeynote">{{ row.currentGate }}</span>
                @if (row.nextGate != null) {
                  <span class="shift shift--gate-next">
                    <span class="shift__arrow" [attr.title]="row.gateShiftAtTooltip">▸</span>
                    <span class="shift__value" [attr.title]="row.nextGateKeynote">{{ row.nextGate }}</span>
                  </span>
                }
                @if (countdown?.gate; as gateCountdown) {
                  <span class="shift countdown countdown--prominent">{{ gateCountdown }}</span>
                }
              </span>
            </span>
          </button>
        </li>
      }
    </ul>
  }
</section>
